export class LeaderboardToolTipsConstants {
    public static getText(index: number):string {
        return this.Texts[`icon${index}`];
    }
    public static Texts = {
        icon0: "Мы создаем все условия для развития\nмолодых специалистов\nи поддерживаем их на\nкаждом этапе роста!",
        icon1: "Возможности равны. Мы в одинаковой\nстепени ценим всех наших\nсотрудников.",
        icon2: "Долой стереотипы! Мы знаем, что\nталант организатора и\nуправленца не зависит от пола.",
        icon3: "Нам важно, чтобы сотрудники могли\nреализовать себя и занимались\nлюбимым делом! Создаем все условия\nдля изучения нового в\nкорпоративном университете.",
        icon4: 'Предоставляем ДМС и все виды\nобязательных медицинских осмотров\n для сотрудников,поощряем здоровый\nобраз жизни.Ведь это самое\nглавное!',
        icon5: "Первые месяцы в компании – важный\nэтап знакомства с рабочим процессом\nи коллективом. Мы всегда помогаем\nновым сотрудникам, поэтому\nу нас дружная команда!",
        icon6: 'Мы понимаем, как важен баланс\nработы и отдыха и предоставляем\nспециальные оздоровительные\nпрограммы для сотрудников и их семей.',
        icon7: 'Поздравляем с экологическим\nпросвещением! Секретный бонус собран.'
        
    }
}